// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoweredBy_wrapper__28Iak","text":"PoweredBy_text__lxNjW","logo":"PoweredBy_logo__lvudS"};